import React, { useEffect, useState } from 'react';
import { projectsArray, designProjects } from '../components/projectData';
import WebDevProjects from "../components/webProjects"
import '../styles/webdev.css';
import '../styles/GraphicDesign.css';
// import DrinkCampaignDisplay from '../components/drinkCampaign';
import DesignSectionTwo from '../components/DesignSectionTwo.js';
import PosterSection from '../components/Posters';
import AltNav from '../components/AltNav.js';


//fuck you vercel



export default function WebDev() {





    const [fullView, setFullView] = useState(false);
    const [projectPreview, setProjectPreview] = useState(null);

    const displayProject = (id) => {
        setFullView(true);
        setProjectPreview(id);


    }

    const exitProjectPreview = () => {
        setFullView(false);
        setProjectPreview(null);
    }


    useEffect(() => {
        if (fullView) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        // Clean up when component unmounts
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [fullView]);


    useEffect(() => {
        // Scrolls to the top of the page when the component is mounted
        window.scrollTo(0, 0);
    }, []);


    return (
        <main className="WebDev">

            <AltNav />



            <header style={{ backgroundImage: `url('images/skyline2.png')` }} className='vertical-gradient texture1 header-alt' >


                <div class="glow-wrapper alt-head-txt">
                    <span class="glow-text">OTHER PROJECTS</span>
                    <span class="stroke-text">OTHER PROJECTS</span>
                </div>
            </header>

            <div className='circuit-texture' style={{ backgroundColor: ' #121021;' }}>
                <br />

                {fullView ? (

                    <></>
                ) : (
                    <section id='web-projects-intro'>

                    </section>
                )

                }

                {fullView ? (
                    <div className='project-preview-cont'>
                        <button className='exit-preview-btn' onClick={exitProjectPreview}>
                            <p>
                                Close
                            </p>

                            <div className='close-prev-cont'>
                                <div className='close-preview-bar left-bar'></div>
                                <div className='close-preview-bar right-bar'></div>
                            </div>
                        </button>
                        <div className='web-project-preview'>
                            <img className='project-preview-image' src={`${process.env.PUBLIC_URL}${projectsArray.find(project => project.id === projectPreview).image}`} alt="Preview Image" />

                            <div className='preview-2'>
                                <h3>{projectsArray.find(project => project.id === projectPreview).title}</h3>
                                <h5>{projectsArray.find(project => project.id === projectPreview).shortDescription}</h5>
                                <div className='proj-preview-line'></div>
                                <p className='project-preview-description'>{projectsArray.find(project => project.id === projectPreview).description}</p>
                                <div className='repo-site-btn-container'>

                                    {projectsArray.find(project => project.id === projectPreview).link && (
                                        <a style={{ textDecoration: 'none' }} href={projectsArray.find(project => project.id === projectPreview).link} target='_blank'>
                                            <button className='repo-proj-btn'>
                                                View Site
                                            </button>
                                        </a>
                                    )}

                                    {projectsArray.find(project => project.id === projectPreview).repo && (
                                        <a style={{ textDecoration: 'none' }} href={projectsArray.find(project => project.id === projectPreview).repo} target='_blank'>
                                            <button className='repo-proj-btn'>
                                                View Repo
                                            </button>
                                        </a>
                                    )}

                                </div>


                            </div>
                        </div>
                        <h6>Technologies Used</h6>
                        <div className='tech-used-list'>
                            {projectsArray.find(project => project.id === projectPreview)?.technologies?.map((tech, index) => (
                                <div className='tech-used-cell' key={index}>
                                    <img className='tech-used-icon' src={process.env.PUBLIC_URL + tech.techIcon} alt={`Tech ${index}`} />
                                    <p>{tech.techName}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <section className='web-projects-portfolio  '>
                        <div className="web-projects">
                            {projectsArray.map(project => (
                                <WebDevProjects onClick={displayProject} key={project.id} project={project} />
                            ))}
                        </div>
                    </section>
                )}

                <br />
                <br />

            </div>





            <section id="GD-head">
                <h1 className='heading2'>GRAPHIC DESIGN</h1>
            </section>

            <section>
                <div className='design-section-2'>
                    {designProjects.map(project => (
                        <DesignSectionTwo key={project.id} project={project} />
                    ))}
                </div>
            </section>
            <section className='posters'>
                <PosterSection />
            </section>
            <section id='design-section-3-cont'>
                <div id='design-section-3'>



                    <div id='design-3-title'>

                        <h2 className='heading2'>OTHER WORK</h2>

                    </div>

                    <div className='section-3-flex'>
                        <div className='deseign-3-card'>
                            <div className='design-3-img'>
                                <img className='p3-img' src={process.env.PUBLIC_URL + '/project-images/comicpic.jpg'} ></img>
                            </div>
                            <div className='design-3-description'>
                                <h3>Web Comic</h3>
                                <div className='green-line'></div>
                                <div className='purple-line'></div>
                                <p>I made this web comic for a digital story telling class. It is just about a bunch of guys who go on an adventure. I made it using illustrator and then put it together on wix to save time. Plus this was before I really started coding. View the full story <a style={{ color: 'white' }} href='https://dawson120.wixsite.com/webcomic354' target='_blank'>Here.</a> </p>
                            </div>
                        </div>
                        <div className='deseign-3-card'>
                            <div className='design-3-img'>
                                <img className='p3-img' id="lapel" src={process.env.PUBLIC_URL + '/project-images/Lappel.jpg'}></img>
                            </div>
                            <div className='design-3-description'>
                                <h3>CD Design</h3>
                                <div className='green-line'></div>
                                <div className='purple-line'></div>
                                <p>In my digital media class in high school, we had a project where the graphic design students paired up with the video students in groups. The video students shot a music video while we had to make promotional designs and cd designs. I designed this cd in photoshop.</p>
                            </div>
                        </div>
                    </div>

                    <div className='section-3-flex'>
                        <div className='deseign-3-card'>
                            <div className='design-3-img'>
                                <img className='p3-img' src={process.env.PUBLIC_URL + '/project-images/High.jpg'}></img>
                            </div>
                            <div className='design-3-description'>
                                <h3>Anti Drug ad</h3>
                                <div className='green-line'></div>
                                <div className='purple-line'></div>
                                <p>This is also from high school. It was in my same digital media class that I took as an elective for most of my time in high school. We were tasked with making anti drug adds. Specifically against teenage Cannabis use. I made this in photoshop. The message is to get out and do other things than drugs.</p>
                            </div>
                        </div>
                        <div className='deseign-3-card'>
                            <div className='design-3-img'>
                                <img id='high' className='p3-img' src={process.env.PUBLIC_URL + '/project-images/albumcoverweb.jpg'}></img>
                            </div>
                            <div className='design-3-description'>
                                <h3>Album Cover</h3>
                                <div className='green-line'></div>
                                <div className='purple-line'></div>
                                <p>This was a project from a fine arts class I took in college. The task was to create a mockup album cover design. I leaned heavily towards illustrator for a lot of the projects in this class so I chose to make this project in photoshop and In Design.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </main>
    )
}

//return here